import { Component, HostListener, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject, takeUntil, tap } from 'rxjs';

import {
  NewsCO,
  PageCategoryCO,
  PageCategoryType,
  PageCO,
  PageContentCO,
  SchoolCO,
} from 'src/app/shared/models/ApiModels';

import { ApiUrls } from 'src/app/shared/const/Api-urls';
import { PageDataService } from 'src/app/shared/services/page-data.service';
import { FormBuilder,  } from '@angular/forms';
import { ApiService } from 'src/app/shared/services/api.service';
import { SchoolDetailsService } from 'src/app/shared/services/school-details.service';
import { SchoolMapService } from 'src/app/shared/services/school-map.service';

export interface CarouselSlide {
  imageUrl: string;
  title: string;
  description: string;
}

interface Feature {
  title: string;
  icon: string;
  gradient: string;
}

const MOBILE_BREAKPOINT = 1100;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  school: SchoolCO | null = null;
  showEnquiry = false;
  showAboutFull = false;

  carouselSlides: CarouselSlide[] = [];
  carouselTitleColor = '#fff';
  carouselDescriptionColor = '#fff';

  featuredImageTitle = '';

  aboutUsImage = '';

  schEventImages: any[] = []

  loading$ = this.pageDataService.loading$;
  error$ = this.pageDataService.error$;

  private destroy$ = new Subject<void>();
  carouselType = '';

  homeCategoryMap = new Map<PageCategoryType, PageCategoryCO>();
  constructor(
    private snackBar: MatSnackBar,
    private pageDataService: PageDataService,
    private apiService: ApiService,
    private schoolService: SchoolDetailsService,
    private schoolMapService: SchoolMapService,
  ) {}

  ngOnInit(): void {
    this.pageDataService.loadPageData();
    this.subscribeToSchoolState();
    this.updateScreenSize();
  }

  showDigitalSchoolSection = false;
  showFacilities = false;
  showHighlights = false;

  pageData$ = this.pageDataService.pageData$.pipe(
    tap(data => {
      if (!data?.length) return;

      const homePage = data.find(
        page => page?.name?.toLowerCase() === 'home'
      );

      if (!homePage) return; // ✅ type guard

      this.carouselType = this.schoolMapService.getCarouselType();
      
      this.showDigitalSchoolSection = homePage.category?.some(
        cat => cat.category === PageCategoryType.DIGITAL_SCHOOL
      ) ?? false;
      this.showFacilities =
        homePage.category?.some(
          cat =>
            cat.category === PageCategoryType.FACILITIES &&
            (cat.image?.length ?? 0) > 0
        ) ?? false;
      this.showHighlights =
        homePage.category?.some(
          cat =>
            cat.category === PageCategoryType.FEATURED_IMAGES &&
            (cat.image?.length ?? 0) > 0
        ) ?? false;

      this.extractImages(homePage); // ✅ now safe
    })
  );

  private extractImages(page: PageCO): void {
    if (!page.category?.length) return;

    const categoryMap = new Map<PageCategoryType, PageCategoryCO>();
    page.category.forEach(cat => categoryMap.set(cat.category, cat));

    this.homeCategoryMap = categoryMap;
    this.buildCarousel(categoryMap);
    this.buildAboutUs(categoryMap);
    this.buildSchEvents(categoryMap);
    this.buildFeaturedImages(categoryMap);
    this.buildNewsHeader(categoryMap);
    this.buildAchievements(categoryMap);
  }

// declare var bootstrap: any;

  private buildCarousel(
    map: Map<PageCategoryType, PageCategoryCO>
  ): void {

    const carousel =
      map.get(PageCategoryType.Carousel);

    this.carouselSlides =
      carousel?.image?.map((img) => ({
        imageUrl: this.getFileUrl(img.file.fileUUID),
        title: img.file.title || '',
        description: img.descp || ''
      })) ?? [];

    this.carouselTitleColor =
      carousel?.content
        ?.find(x => x?.msgOrder === 1)
        ?.content
        ?.trim() || '#fff';

    this.carouselDescriptionColor =
      carousel?.content
        ?.find(x => x?.msgOrder === 2)
        ?.content
        ?.trim() || '#fff';
  }

  achievementImages: any[] = [];
  private buildAchievements(
    map: Map<PageCategoryType, PageCategoryCO>
  ): void {

    const achievements =
      map.get(PageCategoryType.ACHIEVEMENTS);

    this.achievementImages =
      achievements?.image?.map((img) => ({
        imageUrl: this.getFileUrl(img.file.fileUUID),
        title: img.file.title || '',
        description: img.descp || ''
      })) ?? [];
    }
  private buildFeaturedImages(map: Map<PageCategoryType, PageCategoryCO>): void {
    const featuredImages = map.get(PageCategoryType.FEATURED_IMAGES);

    this.featuredImageTitle = featuredImages?.content?.[0]?.content?.trim() || 'Campus Highlights';
  }

  newsHeaderBackground = '#2f6d61';
  newsHeaderColor = '#fff';
  newsHeaderText = '';
  private buildNewsHeader(map: Map<PageCategoryType, PageCategoryCO>): void {
    const newsHeader = map.get(PageCategoryType.NEWS_HEADER);

    if (!newsHeader?.content?.length) {
      return;
    }

    const backgroundConfig = newsHeader.content.find(
      item => item.msgOrder === 1
    );

    const colorConfig = newsHeader.content.find(
      item => item.msgOrder === 2
    );

    this.newsHeaderBackground =
      backgroundConfig?.content?.trim() || '#2f6d61';

    this.newsHeaderColor =
      colorConfig?.content?.trim() || '#fff';

    this.newsHeaderText =
      colorConfig?.pageTitle?.trim() || '';
  }



  aboutUs?: PageCategoryCO;
  aboutUsContent?: PageContentCO;
  private buildAboutUs(map: Map<PageCategoryType, PageCategoryCO>): void {
    this.aboutUs = map.get(PageCategoryType.AboutUs);
    this.aboutUsImage = this.aboutUs?.image?.[0]
      ? this.getFileUrl(this.aboutUs.image[0].file.fileUUID)
      : '';
    this.aboutUsContent = this.aboutUs?.content?.[0];console.log(this.aboutUsContent)
  }

  private buildSchEvents(map: Map<PageCategoryType, PageCategoryCO>): void {
    const events = map.get(PageCategoryType.SchEvents);

    this.schEventImages =
      events?.image?.map(img => ({
        imageUrl: this.getFileUrl(img.file.fileUUID),
        title: img.file?.title ?? 'School Event'
      })) ?? [];
  }

  private getFileUrl(uuid: string): string {
    return `${ApiUrls.downloadFileUrl1}${uuid}`;
  }

  private getCarouselTitle(index: number): string {
    return [
      'Welcome to Indo Valley Public School',
      'Certified Teachers',
      'Books and Library'
    ][index] ?? 'Indo Valley Public School';
  }

  private getCarouselDescription(index: number): string {
    return [
      'Get professional education and reliable consultation by certified teachers.',
      'Highly qualified and experienced faculty guiding every student.',
      'One of the most resourceful libraries with thousands of books.'
    ][index] ?? '';
  }

  openEnquiry(): void {
    this.showEnquiry = true;
  }

  closeEnquiry(): void {
    this.showEnquiry = false;
  }

  trackByIndex(index: number): number {
    return index;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private subscribeToSchoolState(): void {
    this.schoolService.schoolState$
      .pipe(takeUntil(this.destroy$))
      .subscribe(state => {
        if (state.loading) {
          return;
        }

        if (state.error) {
          this.showError(state.error);
          return;
        }

        if (!state.data) {
          return;
        }

        this.school = state.data;
        this.getNews();       
      });
  }

  private showError(message: string): void {
    this.snackBar.open(message, 'x', { duration: 3000 });
  }

  private showSuccess(message: string): void {
    this.snackBar.open(message, 'x', { duration: 3000 });
  }

  // latestNews ='';
 // 'Admissions Open for Session 2026–27 | Annual Sports Meet on 5th Feb | Parent-Teacher Meeting on 10th Feb | New Website Launched';
  latestNews: any[] = [];

  getNews() {
    if (!this.school?.id) return;

    this.apiService.getWebNewsList(this.school.id, 30)
      .subscribe((res: any) => {

        const data = res?.data ?? [];
        const today = new Date();

        this.latestNews = data.map((element: any) => {

          const [datePart, timePart] =
            element.publicationDate.split(' ');

          const [day, month, year] =
            datePart.split('/');

          const [hours, minutes, seconds] =
            timePart.split(':');

          const pubDate = new Date(
            Number(year),
            Number(month) - 1,
            Number(day),
            Number(hours),
            Number(minutes),
            Number(seconds)
          );

          const diffDays =
            (today.getTime() - pubDate.getTime()) /
            (1000 * 60 * 60 * 24);

            return {
              id: element.id,
              title: element.newsTitle,
              description: element.newsDescp,
              date: `${day}-${this.getMonthName(month)}-${year}`,
              link: element.link,
              image: element.image,
              isNew: diffDays <= 7,

              originalNews: element
            };
        });
      });
  }

  private getMonthName(month: string): string {
    const months = [
      'Jan', 'Feb', 'Mar', 'Apr',
      'May', 'Jun', 'Jul', 'Aug',
      'Sep', 'Oct', 'Nov', 'Dec'
    ];

    return months[Number(month) - 1];
  }

  features: Feature[] = [
    {
      title: 'Automatic Fee Reminders',
      icon: '💳',
      gradient: 'linear-gradient(135deg, #ff9a9e, #fad0c4)',
    },
    {
      title: 'Digital Report Card',
      icon: '📄',
      gradient: 'linear-gradient(135deg, #a1c4fd, #c2e9fb)',
    },
    {
      title: 'Absent Notification',
      icon: '🚨',
      gradient: 'linear-gradient(135deg, #fbc2eb, #a6c1ee)',
    },
    {
      title: 'Digitalized Teachers',
      icon: '👩‍🏫',
      gradient: 'linear-gradient(135deg, #d4fc79, #96e6a1)',
    },
    {
      title: 'Student App',
      icon: '📱',
      gradient: 'linear-gradient(135deg, #84fab0, #8fd3f4)',
    },
    {
      title: 'Online Payment',
      icon: '💰',
      gradient: 'linear-gradient(135deg, #f6d365, #fda085)',
    },
    {
      title: 'Digital Homework',
      icon: '📚',
      gradient: 'linear-gradient(135deg, #cfd9df, #e2ebf0)',
    },
  ];

  trackByTitle(_: number, feature: Feature): string {
    return feature.title;
  }

  
  isMobile = false;
  @HostListener('window:resize')
  onResize(): void {
    this.updateScreenSize();
  }

  private updateScreenSize(): void {
    this.isMobile = window.innerWidth < MOBILE_BREAKPOINT;
  }
}